import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import { COMING } from "@/constants/testIds";

/**
 * Lightweight placeholder used for routes whose content arrives in later
 * milestones (M2–M5). It keeps navigation intact so the M1 review covers
 * the full site shell without breaking links.
 */
const ComingSoon = ({ slug, title, eyebrow, milestone }) => {
    return (
        <section
            data-testid={COMING.page(slug)}
            className="ih-container py-24 md:py-32"
        >
            <p className="ih-eyebrow">{eyebrow || "In Build"}</p>
            <h1 className="mt-3 font-montserrat font-bold text-indigo_brand text-4xl sm:text-5xl tracking-tight">
                {title}
            </h1>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-gold_brand/15 px-4 py-2">
                <Clock size={14} className="text-gold_brand" />
                <span className="font-poppins text-xs uppercase tracking-[0.16em] text-indigo_brand">
                    Arrives in {milestone}
                </span>
            </div>
            <p className="mt-7 font-opensans text-[#4A5568] text-base max-w-2xl leading-relaxed">
                This section is part of The Intuitus Hub™ Version 1 build and is
                arriving in {milestone}. Milestone 1 (Home, About, HUMAN+
                Framework™) is currently in review.
            </p>
            <Link
                to="/"
                data-testid={COMING.back}
                className="ih-btn-secondary mt-10"
            >
                <ArrowLeft size={16} />
                Return Home
            </Link>
        </section>
    );
};

export default ComingSoon;
